var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockNv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 20H14C11.7909 20 10 21.7909 10 24V38C10 40.2091 11.7909 42 14 42H34C36.2091 42 38 40.2091 38 38V24C38 21.7909 36.2091 20 34 20ZM14 18C10.6863 18 8 20.6863 8 24V38C8 41.3137 10.6863 44 14 44H34C37.3137 44 40 41.3137 40 38V24C40 20.6863 37.3137 18 34 18H14Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 15C13 8.92487 17.9249 4 24 4C30.0751 4 35 8.92487 35 15V19H33V15C33 10.0294 28.9706 6 24 6C19.0294 6 15 10.0294 15 15V19H13V15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockNv);
export default __webpack_public_path__ + "static/media/Lock_nv.8c8cef1249f1845f0ca7a03d88715f48.svg";
export { ForwardRef as ReactComponent };